import { Map } from "ol";
import Feature from "ol/Feature";
import Polygon from "ol/geom/Polygon";
import { Vector as VectorLayer } from "ol/layer";
import LayerGroup from "ol/layer/Group";
import { PortListDto } from "~/api/GeneratedApi";
import { LayerTitle } from "../types/layers";
import { CustomMapEventTypes } from "../types/map";
import { portDtoToPortData } from "./dataConverters";

export function addPortsToMap(map: Map, ports: PortListDto[]): void {
  // Find the ports layer and add the ports as features
  map.getLayers().forEach((l) => {
    if (l instanceof LayerGroup) {
      l.getLayers().forEach((lay) => {
        if (
          lay.get("title") === LayerTitle.Ports &&
          lay instanceof VectorLayer
        ) {
          const source = lay.getSource();
          // Clear the source before adding
          source.clear();
          const features = ports.map((p) => {
            const poly = new Polygon([
              p.points.map((point) => [point.x, point.y]),
            ]);
            const feat = new Feature({
              geometry: poly,
              name: p.name,
            });
            // Convert to internal type
            const convertedPort = portDtoToPortData(p);
            feat.setProperties({ ...convertedPort });
            feat.setId(convertedPort.mapId);
            return feat;
          });
          source.addFeatures(features);
          source.dispatchEvent(CustomMapEventTypes.FeaturesAdded);
          map.dispatchEvent(CustomMapEventTypes.FeaturesAdded);
        }
      });
    }
  });
}
